const talentModelV2Url = '/talent_model/v2';

const TEAM_HIRING_ENDPOINTS = {
  getWorkingStyles: '/working_styles',
  getWinningTraits: '/winning_traits',
  getMembers: '/team_analytics_members',
};

const GRID_COLORS = {
  DARKER: '#EEEEF0',
  LIGHTER: '#FAFAFA',
};

export const TEAM_HIRING_CUSTOM_FILTER_IDS = {
  OUTCOME_METRIC: 'outcome_metric',
  COMPARE_TOP_PERFORMERS: 'compare_top_performers',
};

export { TEAM_HIRING_ENDPOINTS, talentModelV2Url, GRID_COLORS };
